module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-checkbox', {
    attrs: {
      "input-value": _vm.isInPlaylist,
      "label": _vm.playlist.title,
      "color": "primary",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd4aedb0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuAddToPlaylistItem.vue
// module id = 403
// module chunks = 0